import React from 'react';
import { SearchBar } from "./SearchBar";
import { Button } from "./ui/button";
import { LayoutDashboard, Bot, BarChart3, Zap, ShieldCheck } from "lucide-react";
import { useNavigate } from 'react-router-dom';

export function Hero() {
  const navigate = useNavigate();

    return (
    <div className="flex flex-col bg-parchment">
      {/* Editorial Hero Section */}
      <section className="relative pt-[80px] min-h-[90vh] flex items-center overflow-hidden border-b-2 border-ink">
        <div className="container mx-auto px-4 grid grid-cols-1 lg:grid-cols-2 gap-0 items-stretch h-full">
          
          {/* Left Side: Typography & Search */}
          <div className="py-12 lg:py-24 flex flex-col justify-center border-r-0 lg:border-r-2 border-ink pr-0 lg:pr-8 relative z-10 overflow-hidden">
            <div className="mb-4 w-full">
              <span className="inline-block bg-terracotta text-parchment px-3 py-1 text-xs font-bold uppercase tracking-[0.3em] mb-6">
                B2B — Excellence for Brokers
              </span>
              <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-display font-black leading-[1.1] mb-8 text-ink uppercase tracking-tighter max-w-full break-words">
                <span className="italic block">Impulsa tu</span>
                <span className="text-stroke-ink block my-2">Negocio de</span>
                <span className="block">Corretaje</span>
                </h1>
              <p className="text-base md:text-lg font-serif italic text-ink/70 max-w-md mb-12 border-l-4 border-terracotta pl-6 leading-relaxed">
                Entregamos las mejores herramientas del mercado para gestionar el ciclo de vida completo de tus propiedades. OS Inmobiliario, Tasación IA y Compra Directa.
              </p>
        </div>
        
            <div className="flex flex-wrap gap-4 mb-12">
                  <Button
                size="lg" 
                className="h-16 px-12 text-lg"
                onClick={() => navigate('/servicios/crm')}
              >
                EMPEZAR AHORA
                  </Button>
                  <Button
                variant="outline" 
                                      size="lg"
                className="h-16 px-12 text-lg"
                onClick={() => {
                  const servicesSection = document.getElementById('services-grid');
                  if (servicesSection) servicesSection.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                VER SERVICIOS
                            </Button>
                        </div>

            <div className="w-full max-w-2xl brutalist-border bg-parchment p-1">
              <SearchBar />
                </div>
                
            <div className="flex flex-wrap gap-12 mt-16">
              <div className="flex flex-col">
                <span className="text-5xl font-display font-black text-ink">2K+</span>
                <span className="text-[10px] uppercase tracking-[0.3em] font-black text-terracotta">Propiedades</span>
                  </div>
              <div className="flex flex-col">
                <span className="text-5xl font-display font-black text-ink">19+</span>
                <span className="text-[10px] uppercase tracking-[0.3em] font-black text-terracotta">Años Exp.</span>
              </div>
              <div className="flex flex-col">
                <span className="text-5xl font-display font-black text-ink">100%</span>
                <span className="text-[10px] uppercase tracking-[0.3em] font-black text-terracotta">Garantía</span>
                          </div>
                            </div>
                              </div>

          {/* Right Side: Visual Composition & Benefits */}
          <div className="relative bg-ink min-h-[600px] lg:min-h-full overflow-hidden z-0 flex flex-col">
            <div className="flex-1 relative min-h-[500px] flex items-center justify-center p-8 lg:p-12">
              {/* Subtle Noise Texture instead of failing image */}
              <div className="absolute inset-0 opacity-20 grain-texture" />
              
              {/* Geometric Overlays - More dynamic for centered composition */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-terracotta/10 rounded-full blur-3xl" />
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-parchment/5 rounded-full blur-3xl" />
              <div className="absolute top-1/4 left-1/4 w-48 h-48 border border-parchment/10 rotate-45" />
              <div className="absolute bottom-1/4 right-1/4 w-32 h-32 border border-terracotta/20 -rotate-12" />
              
              <div className="relative group cursor-pointer scale-110 lg:scale-125 transition-transform duration-500">
                <div className="absolute -inset-6 bg-terracotta rotate-2 group-hover:rotate-0 transition-transform duration-700 shadow-[20px_20px_0px_0px_rgba(0,0,0,0.3)]" />
                <div className="relative border-2 border-ink overflow-hidden aspect-[3/4] w-[300px] md:w-[400px]">
                  <img 
                    src="https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&q=80" 
                    className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110 grayscale group-hover:grayscale-0"
                    alt="Featured Property"
                  />
                  <div className="absolute bottom-0 left-0 right-0 bg-ink p-8 text-parchment border-t-2 border-parchment/10">
                    <p className="text-[10px] uppercase tracking-[0.4em] mb-3 font-black text-terracotta">Ecosistema Integral</p>
                    <h3 className="text-3xl font-display font-black uppercase leading-[0.9] italic">Software de <br /> Gestión</h3>
                    <p className="text-sm font-serif italic text-parchment/60 mt-3">Para Corredores Independientes</p>
                  </div>
                </div>
              </div>

              <div className="absolute bottom-12 right-12 vertical-text hidden lg:block">
                <span className="text-parchment/30 text-[10px] uppercase tracking-[1em] font-black">
                  PROPIEDADES LATAM — B2B EDITORIAL 2025
                </span>
              </div>
                </div>

            {/* Integrated Benefits Grid */}
            <div className="bg-ink border-t-2 border-parchment/10 p-8 grid grid-cols-2 lg:grid-cols-5 gap-px bg-parchment/10">
              <div className="bg-ink p-6 flex flex-col gap-3">
                <LayoutDashboard className="h-6 w-6 text-terracotta" />
                <h4 className="text-[10px] font-display font-black uppercase text-parchment tracking-widest leading-tight">CRM Inmobiliario</h4>
                <p className="text-[9px] font-serif italic text-parchment/50 leading-relaxed">Sistema operativo central para tu corretaje profesional.</p>
              </div>
              <div className="bg-ink p-6 flex flex-col gap-3">
                <Bot className="h-6 w-6 text-terracotta" />
                <h4 className="text-[10px] font-display font-black uppercase text-parchment tracking-widest leading-tight">Ecosistema IA</h4>
                <p className="text-[9px] font-serif italic text-parchment/50 leading-relaxed">WhatsApp y agentes IA para captura de leads 24/7.</p>
              </div>
              <div className="bg-ink p-6 flex flex-col gap-3">
                <BarChart3 className="h-6 w-6 text-terracotta" />
                <h4 className="text-[10px] font-display font-black uppercase text-parchment tracking-widest leading-tight">Tasación IA</h4>
                <p className="text-[9px] font-serif italic text-parchment/50 leading-relaxed">Valorizaciones precisas basadas en datos del mercado.</p>
              </div>
              <div className="bg-ink p-6 flex flex-col gap-3">
                <Zap className="h-6 w-6 text-terracotta" />
                <h4 className="text-[10px] font-display font-black uppercase text-parchment tracking-widest leading-tight">Vende a Nosotros</h4>
                <p className="text-[9px] font-serif italic text-parchment/50 leading-relaxed">Ofertas al contado y liquidación de activos rápida.</p>
              </div>
              <div className="bg-ink p-6 flex flex-col gap-3 md:col-span-1 col-span-2">
                <ShieldCheck className="h-6 w-6 text-terracotta" />
                <h4 className="text-[10px] font-display font-black uppercase text-parchment tracking-widest leading-tight">Legal & Contable</h4>
                <p className="text-[9px] font-serif italic text-parchment/50 leading-relaxed">Asesoría jurídica y tributaria especializada inmobiliaria.</p>
              </div>
            </div>
                </div>
              </div>
      </section>
    </div>
  );
}
